@for (wallet of wallets; track wallet.type) {
  <span class="campaign-wallet">
    <span class="dot {{ wallet.dotClass }}" aria-hidden="true"></span>
    <span class="label">
      {{ "campaign.wallet.balance" | translate }}
      {{ wallet.labelKey | translate }}
    </span>

    <b>{{ wallet.balance | currency: "BRL" : "symbol" : "1.2-2" }}</b>
  </span>
}
